import * as React from 'react';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import CustomTable from '../../components/atoms/Table'
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Box, Button, IconButton, Paper, Switch, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ActionMenu from 'admin/components/atoms/ActionButton';
import service from '../../api/services';
import SoftButton from 'components/SoftButton';
import toast from 'react-hot-toast';
import { useAuth } from 'AuthContext';

const User = () => {
  const navigate = useNavigate()
const [ isApiLoading , setIsApiLoading ] = React.useState(true)
  const [data, setData] = React.useState([]);
  const [subCategory, setSubCategory] = React.useState([]);
    const [sortValue, setSortValue] = React.useState({sortKey:'name',sortDirection:'asc'});
  const [search, setSearch] = React.useState('');
  const [page, setPage] = React.useState(1);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const columns = [
    { id: 'name', label: 'Categories',sortDirection:'asc',isSorting: true },
    {
      id: 'logo',
      label: 'Logo',
      render: (rows) => (
        <>
          {rows.logo ?
            <img
              src={rows.logo}
              alt="Logo"
              style={{ width: 40, height: 40, objectFit: 'contain', border: '1px solid #ccc', borderRadius: 4 }}
            /> : 'N/A'}
        </>
      ),
    },
    {
      id: 'tile',
      label: 'Tile',
      render: (rows) => (
        <>
          {rows.tile ?
            <img
              src={rows.tile}
              alt="Tile"
              style={{ width: 40, height: 40, objectFit: 'contain', border: '1px solid #ccc', borderRadius: 4 }}
            /> : 'N/A'}
        </>
      ),
    },
    {
      id: 'bannerImage',
      label: 'Image',
      render: (rows) => (
        <>
          {rows.bannerImage ?
            <img
              src={rows.bannerImage}
              alt="Image"
              style={{ width: 40, height: 40, objectFit: 'cover', borderRadius: 4 }}
            /> : 'N/A'}
        </>
      ),
    },
    { id: 'sequenceNumber', label: 'S.No' },
    {
      id: 'subcategory',
      label: 'Sub-categories',
      render: (row) => (
        <Button
          variant="outlined"
          size="small"
          sx={{ borderColor: '#0099aa', color: '#0099aa', textTransform: 'none' }}
          onClick={() => {

            navigate(`/admin/subcategory/${row._id}`);
          }}

        >
          Sub-category
        </Button>
      ),
    },
    {
      id: 'action',
      label: 'Action',
      render: (row) => (
        <ActionMenu
          items={[
            { label: 'Edit', onClick: () => { navigate(`/admin/edit-categories/${row._id}`) } },
            {
              label: 'Remove',
              onClick: () => {
                onRemove(row._id);
              },
            },
          ]}
        />
      ),
    },
  ];
  const onRemove = async (id) => {
      try {
        const response = await service.categories.delete(id);
  
        if ([200, 201].includes(response.status)) {
          toast.success(response.message || 'Category deleted successfully.');
          getUserDetail();
        } else {
          toast.error(response.message || 'Failed to delete Category.');
        }
      } catch (error) {
        const errorMessage = error?.response?.data?.message || 'An error occurred while deleting the Category.';
        toast.error(errorMessage);
        console.error('Deletion error:', error);
      }
    };
  const getUserDetail = async () => {
    setIsApiLoading(true)
    try {
      const response = await service.categories.view({ searchData: search, page, limit: rowsPerPage,sortKey:sortValue.sortKey ,sortDirection:sortValue.sortDirection });
      if (response?.data?.data) {
        setData(response.data);
      }
    } catch (error) {
      console.error("Failed to fetch business users", error);
    }
      setIsApiLoading(false)
  };

  React.useEffect(() => {
    getUserDetail();
  }, [search, page, rowsPerPage,sortValue]);
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Paper className='glassmorphism-card' sx={{ padding: 2, mt: '15px' }}>
        <Box display="flex" alignItems="center" justifyContent={'end'}>
          <SoftButton variant="gradient" color="info" onClick={() => navigate('/admin/add-categories')}>Add</SoftButton>
        </Box>
        <CustomTable
          title="Categories List" columns={columns} rows={data?.data}
          search={search}
          setSearch={setSearch}
          page={page}
          setPage={setPage}
          rowsPerPage={rowsPerPage}
          setRowsPerPage={setRowsPerPage}
          isApiLoading={isApiLoading}
          totalPages={data?.pagination?.totalItems}
          onRequestSort={(id, direction) => {
            setSortValue({sortKey:id,sortDirection:direction})

          }}
        />
      </Paper>
    </DashboardLayout>
  );
}

export default User
